import {
  allie1,
  allie1Mobile,
  allie2,
  appStore,
  backgroundPlv,
  connexion,
  connexionBienvenue,
  connexionBienvenueMobile,
  connexionBienvenuePro,
  connexionBienvenueProMobile,
  connexionMobile,
  creditAgricole,
  googlePlay,
  inscription,
  inscriptionMobile,
  JeuSalonAutomne,
  JeuSalonAutomneMobile,
  journalMeteo,
  journalMeteoMobile,
  journalPro as journalProImg,
  journalProMobile,
  journalStock,
  journalStockMobile,
  landingAppFunctionalityCours,
  landingAppFunctionalityGraphics,
  landingAppFunctionalityJournal,
  landingAppFunctionalityMeteo,
  landingAppFunctionalityNotifications,
  landingAppFunctionalityRadar,
  maskableIcon,
  maskableIconMobile,
  notification,
  notificationMobile,
  preferences,
  preferencesMobile,
  profil,
  profilMobile,
  villageByCaBlack,
  villageByCaBlackMobile,
  villageByCaWhite,
  villageByCaWhiteMobile,
} from './imageUrl';
import { StaticImageData } from 'next/image';

export enum ClippedImageStyle {
  rectangle = 'rectangle',
  contentAside = 'content-aside',
  default = 'default',
  journalPro = 'journal-pro',
  settings = 'settings',
  game = 'game',
  innovationContact = 'innovation-contact',
  innovationBenefice = 'innovation-benefice',
  innovationConceptBloc1 = 'innovation-concept-bloc-1',
  innovationConceptBloc2 = 'innovation-concept-bloc-2',
  innovationConceptBloc3 = 'innovation-concept-bloc-3',
  innovationHighlightcard = 'innovation-highlight-card',
  innovationDetailHeader = 'innovationDetailHeader',
}

export type ImageSrc =
  | 'journal-pro'
  | 'journal-meteo'
  | 'journal-stocks'
  | 'innovation'
  | 'allie-1'
  | 'allie-2'
  | 'inscription'
  | 'connexion'
  | 'bienvenue'
  | 'bienvenue-pro'
  | 'notifications'
  | 'preferences'
  | 'profil'
  | 'plv'
  | 'game'
  | 'ca-logo'
  | 'pwa-banner'
  | 'village-by-ca-black'
  | 'village-by-ca-white'
  | 'google-play'
  | 'app-store'
  | 'landing-app-functionality-radar'
  | 'landing-app-functionality-meteo'
  | 'landing-app-functionality-journal'
  | 'landing-app-functionality-cours'
  | 'landing-app-functionality-graphics'
  | 'landing-app-functionality-notifications';

type LocalImgFragment = { original: StaticImageData };

export function buildLocalImageSrc(imgSrc: ImageSrc): { desktop: LocalImgFragment; mobile?: LocalImgFragment } {
  switch (imgSrc) {
    case 'pwa-banner': {
      return {
        desktop: {
          original: maskableIcon,
        },
        mobile: {
          original: maskableIconMobile,
        },
      };
    }
    case 'ca-logo': {
      return {
        desktop: {
          original: creditAgricole,
        },
      };
    }
    case 'journal-pro': {
      return {
        desktop: {
          original: journalProImg,
        },
        mobile: {
          original: journalProMobile,
        },
      };
    }
    case 'game': {
      return {
        desktop: {
          original: JeuSalonAutomne,
        },
        mobile: {
          original: JeuSalonAutomneMobile,
        },
      };
    }
    case 'journal-meteo': {
      return {
        desktop: {
          original: journalMeteo,
        },
        mobile: {
          original: journalMeteoMobile,
        },
      };
    }
    case 'journal-stocks': {
      return {
        desktop: {
          original: journalStock,
        },
        mobile: {
          original: journalStockMobile,
        },
      };
    }
    case 'allie-1': {
      return {
        desktop: {
          original: allie1,
        },
        mobile: {
          original: allie1Mobile,
        },
      };
    }
    case 'allie-2': {
      return {
        desktop: {
          original: allie2,
        },
      };
    }
    case 'inscription': {
      return {
        desktop: {
          original: inscription,
        },
        mobile: {
          original: inscriptionMobile,
        },
      };
    }
    case 'connexion': {
      return {
        desktop: {
          original: connexion,
        },
        mobile: {
          original: connexionMobile,
        },
      };
    }
    case 'bienvenue': {
      return {
        desktop: {
          original: connexionBienvenue,
        },
        mobile: {
          original: connexionBienvenueMobile,
        },
      };
    }
    case 'bienvenue-pro': {
      return {
        desktop: {
          original: connexionBienvenuePro,
        },
        mobile: {
          original: connexionBienvenueProMobile,
        },
      };
    }
    case 'notifications': {
      return {
        desktop: {
          original: notification,
        },
        mobile: {
          original: notificationMobile,
        },
      };
    }
    case 'preferences': {
      return {
        desktop: {
          original: preferences,
        },
        mobile: {
          original: preferencesMobile,
        },
      };
    }
    case 'profil': {
      return {
        desktop: {
          original: profil,
        },
        mobile: {
          original: profilMobile,
        },
      };
    }
    case 'plv': {
      return {
        desktop: {
          original: backgroundPlv,
        },
      };
    }
    case 'village-by-ca-white': {
      return {
        desktop: {
          original: villageByCaWhite,
        },
        mobile: {
          original: villageByCaWhiteMobile,
        },
      };
    }
    case 'village-by-ca-black': {
      return {
        desktop: {
          original: villageByCaBlack,
        },
        mobile: {
          original: villageByCaBlackMobile,
        },
      };
    }
    case 'google-play': {
      return {
        desktop: {
          original: googlePlay,
        },
        mobile: {
          original: googlePlay,
        },
      };
    }
    case 'app-store': {
      return {
        desktop: {
          original: appStore,
        },
        mobile: {
          original: appStore,
        },
      };
    }
    case 'landing-app-functionality-radar': {
      return {
        desktop: {
          original: landingAppFunctionalityRadar,
        },
        mobile: {
          original: landingAppFunctionalityRadar,
        },
      };
    }
    case 'landing-app-functionality-journal': {
      return {
        desktop: {
          original: landingAppFunctionalityJournal,
        },
        mobile: {
          original: landingAppFunctionalityJournal,
        },
      };
    }
    case 'landing-app-functionality-graphics': {
      return {
        desktop: {
          original: landingAppFunctionalityGraphics,
        },
        mobile: {
          original: landingAppFunctionalityGraphics,
        },
      };
    }
    case 'landing-app-functionality-cours': {
      return {
        desktop: {
          original: landingAppFunctionalityCours,
        },
        mobile: {
          original: landingAppFunctionalityCours,
        },
      };
    }
    case 'landing-app-functionality-meteo': {
      return {
        desktop: {
          original: landingAppFunctionalityMeteo,
        },
        mobile: {
          original: landingAppFunctionalityMeteo,
        },
      };
    }
    case 'landing-app-functionality-notifications': {
      return {
        desktop: {
          original: landingAppFunctionalityNotifications,
        },
        mobile: {
          original: landingAppFunctionalityNotifications,
        },
      };
    }
    default: {
      return imgSrc as never;
    }
  }
}
